module.exports = __webpack_public_path__ + "static/img/signet-yg.63cf88d0.png";